var numOfSlides = 0;
var currentSlide = 0;
var intervalId;

$(function() {

  $(window).load(function() {
    if ($("#trends_description_images img").length > 0) {
      $("#trends_description_images img").each(function() {
        var div = $("<div></div>");
        div.addClass("trends_carousel_item")
           .css({
             "background-image": "url('" + $(this).attr("src") + "')"
           });
        $("#trends_carousel").append(div);
      });
    }



    numOfSlides = $("#trends_carousel .trends_carousel_item").length;

    var indexBgLast = $("#trends_carousel .trends_carousel_item:last-child").clone().addClass("cloned");
    var bgImg = indexBgLast.css("background-image");
    indexBgLast.removeAttr("id")/*.css({"background-image": bgImg, "left": "-100%"})*/;

    var indexBgFirst = $("#trends_carousel .trends_carousel_item:first-child").clone().addClass("cloned");
    var bgImg = indexBgFirst.css("background-image");
    indexBgFirst.removeAttr("id")/*.css({"background-image": bgImg, "left": (numOfSlides * 100) + "%"})*/;

    $("#trends_carousel").prepend(indexBgLast);
    $("#trends_carousel").append(indexBgFirst);

    $("#trends_carousel_selector .trends_carousel_selector:first-child").addClass("item_active");
    autoPlay();
  });

  $("#trends_carousel .trends_carousel_item").on("click", function() {
    location.href = "/collections/trends/" + $(this).attr("title").toLowerCase().replace(/ /g, "-");
  });

  $("#bg_prev").on("click", function() {
    if ($(this).hasClass("clickable")) {
      $(this).removeClass("clickable");
      currentSlide--;

      $("#trends_carousel").animate({"left": (currentSlide * -100) + "%"}, 1000, function() {
        if (currentSlide == -1) {
          currentSlide = numOfSlides - 1;
          $("#trends_carousel").css({"left": (currentSlide * -100) + "%"});
        }
        $("#bg_prev").addClass("clickable");

        $("#trends_carousel_selector .trends_carousel_selector").removeClass("item_active");
        $($("#trends_carousel_selector .trends_carousel_selector").get(currentSlide)).addClass("item_active");
      });

      clearInterval(intervalId);
      autoPlay();
    }
  });

  $("#bg_next").on("click", function() {
    if ($(this).hasClass("clickable")) {
      $(this).removeClass("clickable");
      currentSlide++;

      $("#trends_carousel").animate({"left": (currentSlide * -100) + "%"}, 1000, function() {
        if (currentSlide == numOfSlides) {
          currentSlide = 0;
          $("#trends_carousel").css({"left": "0"});
        }
        $("#bg_next").addClass("clickable");

        $("#trends_carousel_selector .trends_carousel_selector").removeClass("item_active");
        $($("#trends_carousel_selector .trends_carousel_selector").get(currentSlide)).addClass("item_active");
      });

      clearInterval(intervalId);
      autoPlay();
    }
  });

  $("#trends_carousel_selector .trends_carousel_selector").on("click", function() {
    currentSlide = $(this).index();
    $("#trends_carousel").animate({"left": (currentSlide * -100) + "%"}, 1000);

    $("#trends_carousel_selector .trends_carousel_selector").removeClass("item_active");
    $($("#trends_carousel_selector .trends_carousel_selector").get(currentSlide)).addClass("item_active");

    clearInterval(intervalId);
    autoPlay();
  });



});

function autoPlay() {
  intervalId = setInterval(function() {
    $("#bg_next").trigger("click");
  }, 8000);
}
